import React, { useLayoutEffect } from 'react';
import {
  Content,
  ContentContainer,
  PageContainer,
  Title,
  BoldText,
  Text,
  StyledSubtitle,
  StyledCallToAction,
} from './Hikes.styles';
import { useTranslation } from 'react-i18next';

export const Szkocja = () => {
  const { t } = useTranslation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <ContentContainer>
        <Content>
          <Title>{t('hiking.szkocja')}</Title>
          <BoldText>{t('hiking.destination-szkocja')}</BoldText>
          <BoldText>{t('hiking.date-szkocja')}</BoldText>

          <StyledSubtitle>{t('szkocja.subtitle0')}</StyledSubtitle>
          <Text>{t('szkocja.description')}</Text>

          <StyledSubtitle>{t('szkocja.subtitle1')}</StyledSubtitle>
          <Text>{t('szkocja.description0')}</Text>

          <StyledSubtitle>{t('szkocja.subtitle2')}</StyledSubtitle>

          <StyledSubtitle>{t('szkocja.subtitle3')}</StyledSubtitle>
          <Text>{t('szkocja.description1')}</Text>

          <StyledSubtitle>{t('szkocja.subtitle4')}</StyledSubtitle>
          <Text>{t('szkocja.description2')}</Text>

          <StyledSubtitle>{t('szkocja.subtitle5')}</StyledSubtitle>
          <Text>{t('szkocja.description3')}</Text>

          <StyledSubtitle>{t('szkocja.subtitle6')}</StyledSubtitle>
          <Text>{t('szkocja.description4')}</Text>

          <StyledSubtitle>{t('szkocja.subtitle7')}</StyledSubtitle>
          <Text>{t('szkocja.description5')}</Text>

          <StyledSubtitle>{t('szkocja.subtitle8')}</StyledSubtitle>
          <Text>{t('szkocja.description6')}</Text>

          <StyledSubtitle>{t('szkocja.subtitle9')}</StyledSubtitle>
          <Text>{t('szkocja.description7')}</Text>

          <StyledCallToAction>
            <StyledSubtitle>{t('szkocja.cta')}</StyledSubtitle>
          </StyledCallToAction>

          <Text
            style={{
              fontSize: '0.9rem',
              fontStyle: 'italic',
              marginTop: '20px',
            }}
          >
            {t('szkocja.notice')}
          </Text>
        </Content>
      </ContentContainer>
    </PageContainer>
  );
};
